// isValueANumber returns true if the provided value is a number.
export const isValueANumber = (value: unknown): boolean => !isNaN(Number(value));

// isUUID returns true if the provided value is a UUID.
export const isUUID = (value: unknown): boolean => {
  if (typeof value !== 'string') {
    return false;
  }
  return /[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}/.test(value);
};
